import axios from 'axios';

/** Map machine_content payload onto the article helpers (same fields, other names). */
export const toContentItemShape = (item) => {
  if (!item) {
    return item;
  }
  return {
    ...item,
    article_media: item.article_media || item.machine_content_media || [],
    article_photo: (item.article_photo || item.machine_content_photo || []).map((photo) => ({
      ...photo,
      article_photo_image: photo.article_photo_image || photo.machine_content_photo_image || [],
    })),
    article_gallery_item: item.article_gallery_item
      ?? (Array.isArray(item.machine_content_gallery_item)
        ? item.machine_content_gallery_item.map((row) => ({
          ...row,
          article_photo: row.article_photo || (row.machine_content_photo
            ? {
              ...row.machine_content_photo,
              article_photo_image: row.machine_content_photo.machine_content_photo_image || [],
            }
            : null),
        }))
        : undefined),
  };
};

export const fetchMachineContents = async (machineId) => {
  const { data } = await axios.get('machine-content', { params: { machine_id: machineId } });
  return (data || []).map(toContentItemShape);
};

export const fetchMachineContent = async (id) => {
  const { data } = await axios.get(`machine-content/${id}`);
  return toContentItemShape(data);
};

export const createMachineContent = (formData) => axios.post('machine-content', formData);

export const updateMachineContent = (id, formData) => axios.patch(`machine-content/${id}`, formData);

export const deleteMachineContent = (id) => axios.delete(`machine-content/${id}`);
